import { Api } from "api";

export const getLocations = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_locations/?hash_pw=${hash}`);
  return res.data;
};

export const getLocationsByUser = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_locations_by_user/?hash_pw=${hash}`);
  return res.data;
};

export const addLocation = async (location: string) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/add_location/?hash_pw=${hash}&location=${location}`);
  return res.data;
};

export const changeLocationStatus = async (location_id: number, status: boolean) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/change_location_status/?hash_pw=${hash}&location_id=${location_id}&status=${status}`);
  return res.data;
};
